import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class DetailedInputService {

  _term = new Subject();
  term: Observable<any>  = this._term.asObservable();

  _hasFocus = new Subject();
  hasFocus: Observable<any> = this._hasFocus.asObservable();

  setTerm (term: string) {
    this._term.next(term);
  }

  setFocus (hasFocus: boolean) {
    this._hasFocus.next(hasFocus);
  }
}
